module.exports = __webpack_public_path__ + "img/logo-white.svg?0c9dca75f05dfd94e58c3312a0063365";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/src/assets/img/logo-white.svg
// module id = 66
// module chunks = 0